interface InvestmentStatsCardProps {
  investmentValue: number;
  percentageChange: number;
  periodLabel?: string;
  chartData?: number[];
}

export function InvestmentStatsCard({
  investmentValue,
  percentageChange,
  periodLabel = "Últimos 7 dias",
}: InvestmentStatsCardProps) {
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value);
  };

  const isPositive = percentageChange >= 0;

  return (
    <div className="bg-[#15203C] border border-[#7846FF] box-border flex flex-col gap-[20px] h-[209px] items-start justify-center px-[30px] py-0 rounded-[20px] w-[403px]">
      {/* Header */}
      <div className="flex flex-col gap-[10px] items-start w-full">
        {/* Title Row */}
        <div className="flex gap-[113px] items-center w-[351px]">
          <div className="flex gap-[7px] items-center">
            <p className="font-['Plus_Jakarta_Sans'] font-semibold leading-normal text-[#f6f6f6] text-[16px] w-[108px]">
              Investimento
            </p>
            <div className="bg-[#0C1427] flex gap-[10px] h-[23px] items-center justify-center rounded-[20px] w-[45px]">
              <p className="font-['Plus_Jakarta_Sans'] font-normal leading-normal text-[12px] whitespace-pre"
                 style={{ color: isPositive ? '#13D480' : '#DC4426' }}>
                {isPositive ? '+' : ''}{percentageChange}%
              </p>
            </div>
          </div>
          <p className="font-['Plus_Jakarta_Sans'] font-normal leading-normal text-[#888888] text-[12px] w-[81px]">
            {periodLabel}
          </p>
        </div>

        {/* Value */}
        <p className="font-['Plus_Jakarta_Sans'] font-bold leading-normal text-white text-[20px] w-full">
          {formatCurrency(investmentValue)}
        </p>
      </div>

      {/* Chart Placeholder */}
      <div className="flex gap-[32px] items-start">
        <div className="h-[46.75px] w-[345px] bg-[#0C1427] rounded-[6px] flex items-center justify-center">
          <p className="text-[#888888] text-[12px]">Gráfico de investimento</p>
        </div>
      </div>

      {/* Legend */}
      <div className="flex gap-[6px] items-start">
        <div className="flex gap-[10px] items-center justify-center w-[98px]">
          <div className="w-[7px] h-[7px] rounded-full bg-[#7846FF]" />
          <p className="font-['Plus_Jakarta_Sans'] font-normal leading-normal text-white text-[12px] whitespace-pre">
            Completos
          </p>
        </div>
        <div className="flex gap-[10px] items-center justify-center w-[98px]">
          <div className="w-[7px] h-[7px] rounded-full bg-[#DC4426]" />
          <p className="font-['Plus_Jakarta_Sans'] font-normal leading-normal text-white text-[12px] whitespace-pre">
            Rejeitadas
          </p>
        </div>
      </div>
    </div>
  );
}
